<mat-toolbar style="padding-left: 0; padding-right: 0; background-color: white;">

  <button mat-button (click)="toggleMenu()" style="background-color:#525252; color:white; height: 100%;">
    <mat-icon aria-label="Open het menu" title="Open het menu">menu</mat-icon>
  </button>

  <div style="width:100%; text-align: center;">{{titel}}</div>

</mat-toolbar>
